import { Image } from '@cian/ui-kit';
import { IconMapPin16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

interface INewbuildingMapPreview {
  imgSrc: string;
  onClick(): void;
}

export const NewbuildingMapPreview: React.FC<INewbuildingMapPreview> = ({ imgSrc, onClick }) => {
  return (
    <div className={styles['container']} onClick={onClick}>
      <div className={styles['icon']}>
        <IconMapPin16 color="icon-main-default" />
      </div>
      <Image objectFit="cover" src={imgSrc} />
    </div>
  );
};
